import {
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnknownFieldExceptionClass;
function UnknownFieldException() {
  if (UnknownFieldExceptionClass === VOID) {
    class $ extends SerializationException() {
      constructor(message) {
        return new.target.new_kotlinx_serialization_UnknownFieldException_1sbngk_k$(message);
      }
      static new_kotlinx_serialization_UnknownFieldException_1sbngk_k$(message) {
        var $this = this.new_kotlinx_serialization_SerializationException_jj1itu_k$(message);
        captureStack($this, $this.$throwableCtor_5);
        return $this;
      }
      static new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(index) {
        return this.new_kotlinx_serialization_UnknownFieldException_1sbngk_k$('An unknown field for index ' + index);
      }
    }
    initMetadataForClass($, 'UnknownFieldException');
    UnknownFieldExceptionClass = $;
  }
  return UnknownFieldExceptionClass;
}
function init_kotlinx_serialization_SerializationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_4);
}
var SerializationExceptionClass;
function SerializationException() {
  if (SerializationExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static new_kotlinx_serialization_SerializationException_ux6c97_k$() {
        var $this = this.new_kotlin_IllegalArgumentException_pv5o3f_k$();
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
      static new_kotlinx_serialization_SerializationException_jj1itu_k$(message) {
        var $this = this.new_kotlin_IllegalArgumentException_sfqr8_k$(message);
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
      static new_kotlinx_serialization_SerializationException_pjmzgo_k$(message, cause) {
        var $this = this.new_kotlin_IllegalArgumentException_afpr0i_k$(message, cause);
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'SerializationException', $.new_kotlinx_serialization_SerializationException_ux6c97_k$);
    SerializationExceptionClass = $;
  }
  return SerializationExceptionClass;
}
var MissingFieldExceptionClass;
function MissingFieldException() {
  if (MissingFieldExceptionClass === VOID) {
    class $ extends SerializationException() {
      constructor(message, cause, missingFields, serialName) {
        return new.target.new_kotlinx_serialization_MissingFieldException_bpcb5_k$(message, cause, missingFields, serialName);
      }
      static new_kotlinx_serialization_MissingFieldException_bpcb5_k$(message, cause, missingFields, serialName) {
        var $this = this.new_kotlinx_serialization_SerializationException_pjmzgo_k$(message, cause);
        captureStack($this, $this.$throwableCtor_5);
        $this.missingFields_1 = missingFields;
        $this.serialName_1 = serialName;
        return $this;
      }
      static new_kotlinx_serialization_MissingFieldException_2xrfvb_k$(missingFields, serialName) {
        var tmp0_message = missingFields.get_size_woubt6_k$() === 1 ? "Field '" + missingFields.get_c1px32_k$(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing";
        return this.new_kotlinx_serialization_MissingFieldException_bpcb5_k$(tmp0_message, null, missingFields, serialName);
      }
      static new_kotlinx_serialization_MissingFieldException_r3nret_k$(missingField, serialName) {
        var tmp0_missingFields = listOf(missingField);
        var tmp1_message = "Field '" + missingField + "' is required for type with serial name '" + serialName + "', but it was missing";
        return this.new_kotlinx_serialization_MissingFieldException_bpcb5_k$(tmp1_message, null, tmp0_missingFields, serialName);
      }
      withNewMessageInternal_ocnlki_k$(newMessage) {
        return MissingFieldException().new_kotlinx_serialization_MissingFieldException_bpcb5_k$(newMessage, this, this.missingFields_1, this.serialName_1);
      }
    }
    initMetadataForClass($, 'MissingFieldException');
    MissingFieldExceptionClass = $;
  }
  return MissingFieldExceptionClass;
}
//region block: exports
export {
  MissingFieldException as MissingFieldException24tqif29emcmi,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  UnknownFieldException as UnknownFieldExceptiona60e3a6v1xqo,
};
//endregion

//# sourceMappingURL=SerializationExceptions.mjs.map
